var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "main-internal-section width-full float-l" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.cantAccessPage === true
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "chat-btm-section-main add-user-main-section width-full float-l"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "chat-web-section chat-user-list-main float-l width-full"
                          },
                          [
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "chat-page-title float-l color-333333 heading-text-24 line-height-28 font-bold ucase pb_5"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.pageTitle) +
                                    " \n                                "
                                ),
                                _c("span", [_vm._v("(All times are in PST)")])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "user-listing-section-web customer-listing-section-web float-l width-full selection_schedule_container"
                              },
                              [
                                !_vm.isUpdate
                                  ? [
                                      _c("v-select", {
                                        attrs: {
                                          name: "timezoneId",
                                          placeholder: "Select Section",
                                          label: "text",
                                          options: _vm.sectionArr,
                                          id: "sectionSelectWeb"
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.changeSectionId()
                                          }
                                        },
                                        model: {
                                          value: _vm.sectionId,
                                          callback: function($$v) {
                                            _vm.sectionId = $$v
                                          },
                                          expression: "sectionId"
                                        }
                                      })
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        { staticClass: "form-control" },
                                        [_vm._v(_vm._s(_vm.sectionId.text))]
                                      )
                                    ],
                                _vm._v(" "),
                                _c("span", { staticClass: "help is-danger" }, [
                                  _vm._v(_vm._s(_vm.sectionError))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-listing-section-web customer-listing-section-web float-l width-full"
                                  },
                                  [
                                    _c("span", { staticClass: "content" }, [
                                      _vm._v("Select Start Time")
                                    ]),
                                    _vm._v(" "),
                                    _c("vue-timepicker", {
                                      attrs: {
                                        "close-on-complete": "",
                                        "minute-range": [0],
                                        format: "HH"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.changeStartDate()
                                        }
                                      },
                                      model: {
                                        value: _vm.startTime,
                                        callback: function($$v) {
                                          _vm.startTime = $$v
                                        },
                                        expression: "startTime"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "help is-danger" },
                                      [_vm._v(_vm._s(_vm.startTimeError))]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-listing-section-web customer-listing-section-web float-l width-full selection_schedule_container-pull-right"
                                  },
                                  [
                                    _c("span", { staticClass: "content" }, [
                                      _vm._v("Select End Time")
                                    ]),
                                    _vm._v(" "),
                                    _c("vue-timepicker", {
                                      attrs: {
                                        "close-on-complete": "",
                                        "minute-range": [0],
                                        format: "HH"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.changeEndDate()
                                        }
                                      },
                                      model: {
                                        value: _vm.endTime,
                                        callback: function($$v) {
                                          _vm.endTime = $$v
                                        },
                                        expression: "endTime"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "help is-danger" },
                                      [_vm._v(_vm._s(_vm.endTimeError))]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "register-btn dayforce-id-btn float-l col-12"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary float-l mr_20",
                                        attrs: {
                                          type: "button",
                                          id: "saveScheduleTime"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.saveTimeForSection()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "gradient" }),
                                        _vm._v(
                                          "Save\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary float-l mr_20",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.onCancelClick()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "gradient" }),
                                        _vm._v(
                                          "Cancel\n                                    "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "user-list-mobile float-l width-full mobile_selection_schedule_container"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "add-user-form col-12 float-l mt_10"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group float-l width-full pt_15 pl_15 pr_15 pb_0"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"
                                      },
                                      [_vm._v(" Section ")]
                                    ),
                                    _vm._v(" "),
                                    _c("v-select", {
                                      attrs: {
                                        name: "timezoneId",
                                        placeholder: "Select Section",
                                        label: "text",
                                        options: _vm.sectionArr,
                                        id: "sectionSelectMobile"
                                      },
                                      model: {
                                        value: _vm.sectionId,
                                        callback: function($$v) {
                                          _vm.sectionId = $$v
                                        },
                                        expression: "sectionId"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "help is-danger" },
                                      [_vm._v(_vm._s(_vm.sectionError))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full pt_15 pb_0"
                                      },
                                      [
                                        _c("span", { staticClass: "content" }, [
                                          _vm._v("Select Start Time")
                                        ]),
                                        _vm._v(" "),
                                        _c("vue-timepicker", {
                                          attrs: {
                                            "close-on-complete": "",
                                            "minute-range": [0],
                                            format: "HH"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.changeStartDate()
                                            }
                                          },
                                          model: {
                                            value: _vm.startTime,
                                            callback: function($$v) {
                                              _vm.startTime = $$v
                                            },
                                            expression: "startTime"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "help is-danger" },
                                          [_vm._v(_vm._s(_vm.startTimeError))]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group float-l width-full pt_15 pb_0"
                                      },
                                      [
                                        _c("span", { staticClass: "content" }, [
                                          _vm._v("Select End Time")
                                        ]),
                                        _vm._v(" "),
                                        _c("vue-timepicker", {
                                          attrs: {
                                            "close-on-complete": "",
                                            "minute-range": [0],
                                            format: "HH"
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.changeEndDate()
                                            }
                                          },
                                          model: {
                                            value: _vm.endTime,
                                            callback: function($$v) {
                                              _vm.endTime = $$v
                                            },
                                            expression: "endTime"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "help is-danger" },
                                          [_vm._v(_vm._s(_vm.endTimeError))]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              : [_vm.isRequestComplete ? [_vm._m(0)] : _vm._e()]
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "error-template" }, [
        _c("h1", [_vm._v("\n                                Oops!")]),
        _vm._v(" "),
        _c("h2", [_vm._v("\n                                403 ")]),
        _vm._v(" "),
        _c("div", { staticClass: "error-details" }, [
          _vm._v(
            "\n                                Sorry!, You don't have permission to access this page.\n                            "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58cb7c98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58cb7c98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionScheduler/AddUpdateSectionScheduleTime.vue
// module id = null
// module chunks = 